import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { useTranslation as n } from "../i18n/hooks.js";
import { Drawer as r } from "../drawer/index.js";
import { useAdaptiveOverlay as i } from "../shared/hooks/use-adaptive-overlay.js";
import { SelectPrimitive as a } from "./select-primitive.js";
import { ChevronDownIcon as o, XCloseIcon as s } from "@systemeio/icons";
import { createContext as c, forwardRef as l, useCallback as u, useContext as d, useLayoutEffect as f, useMemo as p, useReducer as m, useRef as h, useState as g } from "react";
import { jsx as _, jsxs as v } from "react/jsx-runtime";
import { createPortal as y } from "react-dom";
//#region src/select/select.tsx
var b = c(null), x = c(null), S = c(!1);
function C() {
	return d(b);
}
function w() {
	let e = C();
	if (!e) throw Error("Select.Input / Select.Option must be used within Select.Root");
	return e;
}
var T = l(({ className: e, children: t, ...n }, i) => /* @__PURE__ */ _(r.Footer, {
	...n,
	ref: i,
	"data-slot": "select-drawer-footer",
	className: e,
	children: /* @__PURE__ */ _("div", {
		className: "flex w-full *:min-w-[90px] *:flex-1",
		children: t
	})
}));
T.displayName = "Select.DrawerFooterChrome";
function E({ children: e }) {
	let t = h(null), [n, r] = g(0), i = u(() => (r((e) => e + 1), () => r((e) => e - 1)), []), a = p(() => ({
		footerRef: t,
		registerDrawerFooter: i
	}), [i]);
	return /* @__PURE__ */ _(x.Provider, {
		value: a,
		children: /* @__PURE__ */ _(S.Provider, {
			value: n > 0,
			children: e
		})
	});
}
function D({ children: e, placeholder: t, disabled: n = !1, readOnly: o = !1, size: s = "md", multiple: c, open: l, defaultOpen: d = !1, onOpenChange: f, drawerTitle: m, align: h = "end", "aria-label": v, ...y }) {
	let x = !!c, S = l !== void 0, [C, w] = g(d), T = S ? l : C, D = u((e, t) => {
		e && (n || o) || (f?.(e, t), !t?.isCanceled && (S || w(e)));
	}, [
		n,
		S,
		f,
		o
	]), O = i(!!T, D), k = p(() => ({
		isMobile: O,
		multiple: x,
		placeholder: t,
		disabled: !!n,
		readOnly: !!o,
		size: s,
		ariaLabel: v,
		drawerTitle: m,
		align: h
	}), [
		O,
		x,
		t,
		n,
		o,
		s,
		v,
		m,
		h
	]), A = O ? /* @__PURE__ */ _(r.Root, {
		open: T,
		onOpenChange: (e) => D(e),
		children: e
	}) : e;
	return /* @__PURE__ */ _(b.Provider, {
		value: k,
		children: /* @__PURE__ */ _(E, { children: /* @__PURE__ */ _(a.Root, {
			...y,
			multiple: c,
			open: T,
			onOpenChange: D,
			disabled: n,
			readOnly: o,
			modal: !O && y.modal,
			children: A
		}) })
	});
}
D.displayName = "Select";
var O = l(({ className: e, placeholder: t, "aria-label": n, ...r }, i) => {
	let s = w(), c = t ?? s.placeholder, l = n ?? s.ariaLabel;
	return /* @__PURE__ */ v(k, {
		...r,
		ref: i,
		size: s.size,
		disabled: s.disabled,
		"aria-label": l,
		className: e,
		children: [/* @__PURE__ */ _(a.Value, { placeholder: c }), /* @__PURE__ */ _(a.Icon, { children: /* @__PURE__ */ _(o, {}) })]
	});
});
O.displayName = "Select.Input";
var k = l(({ disabled: e, onMouseDown: t, "aria-label": n, ...i }, o) => {
	let s = C(), c = e || s?.disabled, l = n ?? s?.ariaLabel;
	return s?.isMobile && !s.readOnly ? /* @__PURE__ */ _(r.Trigger, {
		"data-adaptive-overlay": "drawer",
		"data-slot": "select-trigger",
		"data-testid": "select-trigger",
		render: /* @__PURE__ */ _(a.Trigger, {
			...i,
			ref: o,
			"aria-label": l,
			disabled: c,
			onMouseDown: (e) => {
				e.preventBaseUIHandler(), t?.(e);
			}
		})
	}) : /* @__PURE__ */ _(a.Trigger, {
		...i,
		ref: o,
		"aria-label": l,
		disabled: c,
		onMouseDown: t
	});
});
k.displayName = "Select.Trigger";
var A = l((e, t) => {
	let n = C(), { layout: r = "fixed-height", ...i } = e;
	if (!n) throw Error("Select.Chips must be used inside Select.Root");
	if (!n.multiple) throw Error("Select.Chips requires Select.Root multiple");
	if ("mode" in i) throw Error("Select.Chips owns adaptive layout; use layout or SelectPrimitive.Chips for custom modes");
	return /* @__PURE__ */ _(a.Chips, {
		...i,
		ref: t,
		mode: r === "expanded" ? "expanded" : "fixed"
	});
});
A.displayName = "Select.Chips";
function j({ multiple: e }) {
	let i = d(x), a = d(S), { t: o } = n();
	return i ? /* @__PURE__ */ _("div", {
		ref: i.footerRef,
		className: "contents",
		children: e && !a ? /* @__PURE__ */ _(T, {
			"data-default-footer": "",
			children: /* @__PURE__ */ _(r.Close, {
				render: /* @__PURE__ */ _(t, { variant: "primary" }),
				children: o("public_pages_purchase.form_select.done")
			})
		}) : null
	}) : null;
}
function M({ context: e, children: n }) {
	return /* @__PURE__ */ v(r.Popup, { children: [
		e.drawerTitle ? /* @__PURE__ */ _(r.Header, { children: /* @__PURE__ */ v("div", {
			className: "flex w-full items-start gap-2.5",
			children: [/* @__PURE__ */ _(r.Title, {
				className: "min-w-0 flex-1",
				children: e.drawerTitle
			}), /* @__PURE__ */ _(r.Close, {
				"aria-label": "Close",
				render: /* @__PURE__ */ _(t, {
					variant: "ghost-gray",
					size: "icon-sm"
				}),
				children: /* @__PURE__ */ _(s, { className: "text-icon-primary size-[18px]" })
			})]
		}) }) : /* @__PURE__ */ _(r.Title, {
			className: "sr-only",
			children: e.ariaLabel ?? "Select"
		}),
		/* @__PURE__ */ _(r.Content, {
			className: "gap-0 px-0 py-4",
			children: n
		}),
		/* @__PURE__ */ _(j, { multiple: e.multiple })
	] });
}
var N = l(({ className: t, children: n, ...r }, i) => {
	let o = C();
	if (!o) throw Error("Select.Content must be used inside Select.Root");
	return o.isMobile ? /* @__PURE__ */ _(M, {
		context: o,
		children: /* @__PURE__ */ _(a.Positioner, {
			alignItemWithTrigger: !1,
			className: "relative z-0 w-full",
			style: {
				position: "relative",
				inset: "auto",
				transform: "none",
				maxWidth: "none"
			},
			children: /* @__PURE__ */ _(a.Popup, {
				...r,
				ref: i,
				className: e("max-h-none w-full max-w-none min-w-0 rounded-none border-0 bg-transparent py-0 shadow-none", t),
				children: n
			})
		})
	}) : /* @__PURE__ */ _(a.Portal, { children: /* @__PURE__ */ _(a.Positioner, {
		align: o.align,
		className: "z-50",
		children: /* @__PURE__ */ _(a.Popup, {
			...r,
			ref: i,
			className: t,
			children: n
		})
	}) });
});
N.displayName = "Select.Content";
var P = l(({ className: t, ...n }, r) => {
	let i = C();
	return /* @__PURE__ */ _(a.List, {
		...n,
		ref: r,
		className: e(i?.isMobile && "overflow-y-visible overscroll-auto", t)
	});
});
P.displayName = "Select.List";
var F = l(({ value: e, disabled: t, className: n, children: r, textValue: i, label: o, ...s }, c) => {
	let l = C(), u = o ?? r, d = i ?? (typeof u == "string" ? String(u) : void 0);
	return /* @__PURE__ */ v(a.Item, {
		...s,
		ref: c,
		value: e,
		disabled: t,
		className: n,
		label: d,
		children: [
			l?.multiple ? /* @__PURE__ */ _(a.ItemIndicator, {
				keepMounted: !0,
				className: "contents",
				render: (e, t) => /* @__PURE__ */ _("span", {
					...e,
					children: /* @__PURE__ */ _(a.ItemCheckbox, { checked: t.selected })
				})
			}) : null,
			/* @__PURE__ */ _(a.ItemText, { children: u }),
			l?.multiple ? null : /* @__PURE__ */ _(a.ItemIndicator, {})
		]
	});
});
F.displayName = "Select.Option";
var I = l((e, t) => /* @__PURE__ */ _(a.Group, {
	...e,
	ref: t
}));
I.displayName = "Select.Group";
var L = l((e, t) => /* @__PURE__ */ _(a.GroupLabel, {
	...e,
	ref: t
}));
L.displayName = "Select.GroupLabel";
var R = l(({ className: e, children: t, ...n }, r) => {
	let i = C(), a = d(x), [, o] = m((e) => e + 1, 0);
	if (f(() => {
		o();
	}, []), f(() => {
		if (a) return a.registerDrawerFooter();
	}, [a]), !i?.isMobile) return null;
	let s = /* @__PURE__ */ _(T, {
		...n,
		ref: r,
		className: e,
		"data-consumer-drawer-footer": "",
		children: t
	}), c = a?.footerRef.current;
	return c ? y(s, c) : s;
});
R.displayName = "Select.DrawerFooter";
//#endregion
export { A as SelectChips, N as SelectContent, R as SelectDrawerFooter, I as SelectGroup, L as SelectGroupLabel, O as SelectInput, P as SelectList, F as SelectOption, D as SelectRoot, k as SelectTrigger };
